<template>
	<font>{{ display_text }}</font>
</template>

<script>
import Vue from 'vue';
export default {
	props: {
		header: {
			type: Object,
			default: () => ({}),
		},
		row: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		display_text() {
			let txt = this.row[this.header.key];

			if (this.header.display_default !== undefined && !txt) {
				if (typeof this.header.display_default === 'object') {
					txt = this.row[this.header.display_default['prop']];
				} else {
					txt = this.header.display_default;
				}
			}

			if (this.header.display_filter) {
				txt = Vue.filter(this.header.display_filter)(txt);
			}

			return txt;
		},
	},
};
</script>

<style></style>
